import { ComponentProps, FC } from "react";

import { Image } from "@mantine/core";

import LogoUrl from "@assets/logo.png";

export const Logo: FC<ComponentProps<typeof Image>> = (props) => {
  return <Image src={LogoUrl} width={194} height={49} {...props} />;
};
